// Module
var code = "<wt-generic-search-bar criteria=\"vm.searchCriteria\" filtered-items=\"vm.filtered\" items=\"vm.dashboards\" placeholder=\"Search for dashboards (d:dashboard name gt:group type cat:category)\"> </wt-generic-search-bar>";
// Exports
module.exports = code;